<template>
    <div class="child2">
        <el-table
                :data="tableData"
                v-loading="loading"
                size="small"
                stripe
                highlight-current-row
                style="width: 100%;"
                @selection-change="handleSelectionChange"
                @sort-change="handleSortChange"
        >

            <el-table-column
                    type="selection"
                    width="55"
            >
            </el-table-column>
            <el-table-column
                    label="公司"
            >
                <template slot-scope="scope">
                    {{scope.row.agentname}}
                </template>
            </el-table-column>

            <el-table-column
                    label="联系人"
                    prop="legal"
                    sortable="custom"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.legal}}
                </template>
            </el-table-column>
            <el-table-column
                    label="手机号"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.mobileNo}}
                </template>
            </el-table-column>
            <el-table-column
                    label="用户名"
                    prop="userCode"
                    sortable="custom"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    {{scope.row.userCode}}
                </template>
            </el-table-column>
            <el-table-column
                    label="合作期限"
                    prop="userCode"
                    sortable="custom"
                    :show-overflow-tooltip="true"
                    width="150"
            >
                <template slot-scope="scope">
                    {{scope.row.contractstdate}}/{{scope.row.contractendate}}
                </template>
            </el-table-column>
            <el-table-column
                    label="状态"
                    prop="pass"
                    sortable="custom"
                    :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.pass=='0'">
                        已签约
                    </div>
                    <div v-else-if="scope.row.pass=='1'">
                        未签约
                    </div>
                </template>
            </el-table-column>

        </el-table>
        <div style="text-align: center;margin-top: 30px;">
            <el-pagination
                    :current-page="page.current"
                    :page-size="page.size"
                    :total="page.total"
                    :page-sizes="[1,10,50,100, 200, 300, 400]"
                    layout="total, sizes, prev, pager, next, jumper"
                    style="margin: -10px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    export default {
        name: "child1",
        props: ["agentid_f","xt_id_f","dl_type_f"],
        components: { },
        data() {
            return {
                loading: false,
                tableData: [],
                multipleSelection: [],
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sort: {
                    prop: "",
                    order: ""
                },
                oneagent: {},
                editFormVisible: false
            };
        },

    watch: {
        agentid_f(val) {
            console.log("###########");
            this.getTableData();
        }
    } ,
        mounted() {

            console.log("========");
            this.getTableData();
        },
        methods: {
            getTableData() {
                let query = {
                    pageIndex: this.page.current,
                    pageSize: this.page.size,
                    sortBy: this.sort.prop,
                    agentid: this.agentid_f,
                    dl_type: this.dl_type_f,
                    dl_type2:'0',
                    xt_id:this.xt_id_f,
                    descending: this.sort.order === "descending",
                    filter: this.searchForm
                };
                agentService.getAgentPagedList(query).then(data => {
                    this.tableData = data.rows;
                    this.page.total = data.totalCount;
                });
            },
            handleSearchFormSubmit() {
                this.getTableData();
            },
            handleSearchFormReset() {
                this.$refs.searchForm.resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData();
            }
        }
    };
</script>